import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "status", "submit", "submitLabel", "spinner"]

  fileSelected() {
    const file = this.inputTarget.files?.[0]
    this.rowCount = null
    if (!file) {
      this.statusTarget.classList.add("hidden")
      return
    }

    const reader = new FileReader()
    reader.onload = (e) => {
      this.rowCount = this.countRows(e.target.result)
      this.statusTarget.textContent = `${file.name} — ${this.rowCount} ${this.rowCount === 1 ? "row" : "rows"} detected`
      this.statusTarget.classList.remove("hidden")
    }
    reader.readAsText(file)
  }

  confirmSubmit(event) {
    const subject = this.rowCount === null
      ? "these travellers"
      : `${this.rowCount} ${this.rowCount === 1 ? "traveller" : "travellers"}`
    const message = `Import ${subject}?\n\nBy continuing, you confirm these contacts have agreed to receive newsletters and marketing emails. They will be imported as opted in unless your file says otherwise.`

    if (!confirm(message)) event.preventDefault()
  }

  loading() {
    this.submitTarget.disabled = true
    this.submitLabelTarget.classList.add("hidden")
    this.spinnerTarget.classList.replace("hidden", "inline-flex")
  }

  loaded() {
    this.submitTarget.disabled = false
    this.submitLabelTarget.classList.remove("hidden")
    this.spinnerTarget.classList.replace("inline-flex", "hidden")
  }

  // Counts data rows (header excluded), ignoring newlines inside quoted fields.
  countRows(text) {
    let rows = 0
    let inQuotes = false
    let lineHasContent = false

    for (const char of text) {
      if (char === '"') inQuotes = !inQuotes
      if (char === "\n" && !inQuotes) {
        if (lineHasContent) rows++
        lineHasContent = false
      } else if (char !== "\r" && char.trim() !== "") {
        lineHasContent = true
      }
    }
    if (lineHasContent) rows++

    return Math.max(rows - 1, 0)
  }
}
